module.exports = __webpack_public_path__ + "media/images/1-c7f0a144b3205eceacb23c743c0c3a0d.svg";